module.exports = __webpack_public_path__ + "img/a3.4c659f17.jpg";